import React from 'react';
import { Modal } from '@vectord/components';

import { CreateSbatGroupLessonForm } from 'features/classCreation';

export default function CreateSbatGroupLessonModal({
  isOpen,
  title,
  lessonType,
  handleClose,
  sbatGroup,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      className="p-b-xs"
      title={title}
      unMountOnClose
      onClose={handleClose}
    >
      <CreateSbatGroupLessonForm
        lessonType={lessonType}
        label={title}
        onSuccess={handleClose}
        sbatGroup={sbatGroup}
      />
    </Modal>
  );
}
